export enum UserActivationLinksStatus {
  NotUsed = 'notUsed',
  Expired = 'expired',
}
